import React, { FC } from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { useTitle } from '@v2/pages/common/hooks/useTitle';

interface JobDetailsNCFileEventsCycleProps {
  ncFileId: number | null;
}

const JobDetailsNCFileEventsCycleComponent: FC<JobDetailsNCFileEventsCycleProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  ncFileId,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.CYCLE, ncFileId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const JobDetailsNCFileEventsCycle = connect(({ details: { ncFileId } }) => ({ ncFileId }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsNCFileEventsCycleComponent);

export { JobDetailsNCFileEventsCycle };
